import {
  List,
  Datagrid,
  TextField,
  EmailField,
  DateField,
  EditButton,
  DeleteButton,
  ShowButton,
  FunctionField,
  ReferenceField,
} from 'react-admin';

export const InquiryList = () => (
  <List>
    <Datagrid rowClick="show">
      <TextField source="name" />
      <TextField source="company" />
      <TextField source="phone" />
      <EmailField source="email" />
      <FunctionField
        label="Comment"
        render={(record: any) => 
          record.comment ? record.comment.substring(0, 50) + (record.comment.length > 50 ? '...' : '') : ''
        }
      />
      <ReferenceField source="userId" reference="users" link="show" empty="-">
        <TextField source="firstName" />
      </ReferenceField>
      <TextField source="source" emptyText="-" />
      <DateField source="createdAt" showTime />
      <ShowButton />
      <EditButton />
      <DeleteButton mutationMode="pessimistic" />
    </Datagrid>
  </List>
);
